
/* --- SLIDER --- */
module.exports = () => {
	jQuery(document).ready(function () {

		jQuery('.slider').each(function() {
			jQuery(this).slick({
				dots: true,
				infinite: false,
				speed: 500,
				slidesToShow: 3,
				slidesToScroll: 3,
				arrows: false,
				centerPadding: '40px',
				autoplay: true,
				autoplaySpeed: 2000,
				mobileFirst: true,
				swipeToSlide: true,
				responsive: [
					{
						breakpoint: 900,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					},
					{
						breakpoint: 540,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]
			})
		});
		jQuery(window).resize(function(){
			jQuery('.slider').slick('resize'); // recalc on window resize
		});


		// continuous pixel by pixel infinite slider
		jQuery('.slider-infinite').each(function() {
			jQuery(this).slick({
				speed: 2000, // increase for slower, decrease for faster
				autoplay: true,
				autoplaySpeed: 0,
				cssEase: 'linear',
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: true,
				arrows: false
			}); 
		})
		jQuery(window).resize(function(){
			jQuery('.slider-infinite').slick('resize'); // recalc on window resize
		});


		// partners logo infinite slider
		jQuery('.partners-slider').each(function() {
			jQuery(this).slick({
				speed: 4000,
				autoplay: true,
				autoplaySpeed: 0,
				cssEase: 'linear',
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: true,
				arrows: false
			}); 
		})
		jQuery(window).resize(function(){
			jQuery('.partners-slider').slick('resize');
		});


		// socials image slider
		jQuery('.socials-slider').each(function() {
			jQuery(this).slick({
				dots: true,
				infinite: false,
				speed: 500,
				slidesToShow: 2,
				slidesToScroll: 1,
				mobileFirst: true,
				arrows: true,
				autoplay: false,
				autoplaySpeed: 3000,
				swipeToSlide: true,
				responsive: [
					{
						breakpoint: 1000,
						settings: {
							slidesToShow: 4
						}
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 3
						}
					}
				]
			});
		});
		jQuery(window).resize(function(){
			jQuery('.socials-slider').slick('resize');
		});


	});
}